// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type UserInstallsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserInstallsQuery = (
  { __typename?: 'Query' }
  & { installationsForUser?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'SourceInstallation' }
    & Pick<Types.SourceInstallation, 'id' | 'name' | 'targetType' | 'repositorySelection' | 'settingsUrl'>
  )>>> }
);

export type GithubRepoInformationQueryVariables = Types.Exact<{
  githubUrl: Types.Scalars['String'];
}>;


export type GithubRepoInformationQuery = (
  { __typename?: 'Query' }
  & { githubRepoInformation: (
    { __typename?: 'GithubRepoInfoResult' }
    & Pick<Types.GithubRepoInfoResult, 'exists'>
    & { repoInfo?: Types.Maybe<(
      { __typename?: 'GithubRepoInfo' }
      & Pick<Types.GithubRepoInfo, 'htmlUrl' | 'id' | 'owner' | 'name' | 'fullName' | 'private' | 'description' | 'defaultBranch'>
    )> }
  ) }
);

export type CmsVendorsForGatsbyProvisionScriptQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type CmsVendorsForGatsbyProvisionScriptQuery = (
  { __typename?: 'Query' }
  & Pick<Types.Query, 'cmsVendorsForGatsbyProvisionScript'>
);

export type ProvisionSetupDataForSiteMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  workspaceId: Types.Scalars['UUID'];
}>;


export type ProvisionSetupDataForSiteMutation = (
  { __typename?: 'Mutation' }
  & { provisionSetupDataForSite: (
    { __typename?: 'ProvisionSetupDataForSiteResult' }
    & { siteProvisionJob?: Types.Maybe<(
      { __typename?: 'SiteProvisionJob' }
      & Pick<Types.SiteProvisionJob, 'id' | 'repoUrl' | 'status' | 'workspaceId' | 'siteId' | 'error'>
    )>, validation?: Types.Maybe<(
      { __typename?: 'MutationResult' }
      & Pick<Types.MutationResult, 'success' | 'message' | 'errorType'>
    )> }
  ) }
);

export type SiteProvisionJobChangedSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type SiteProvisionJobChangedSubscription = (
  { __typename?: 'Subscription' }
  & { siteProvisionJobChanged?: Types.Maybe<(
    { __typename?: 'SiteProvisionJob' }
    & Pick<Types.SiteProvisionJob, 'id' | 'workspaceId' | 'status' | 'siteId' | 'error' | 'repoUrl'>
  )> }
);

export type LogsForSiteProvisionJobQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  jobId: Types.Scalars['ID'];
  offset?: Types.Maybe<Types.Scalars['Int']>;
}>;


export type LogsForSiteProvisionJobQuery = (
  { __typename?: 'Query' }
  & { logsForSiteProvisionJob?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'Log' }
    & Pick<Types.Log, 'id' | 'message' | 'timestamp' | 'sourceStream' | 'command'>
  )>>> }
);

export type SiteProvisionLogCreatedSubscriptionVariables = Types.Exact<{
  jobId: Types.Scalars['ID'];
}>;


export type SiteProvisionLogCreatedSubscription = (
  { __typename?: 'Subscription' }
  & { siteProvisionLogCreated?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'Log' }
    & Pick<Types.Log, 'id' | 'timestamp' | 'message' | 'sourceStream' | 'command' | 'invocationId'>
  )>>> }
);


export const UserInstallsDocument = gql`
    query userInstalls {
  installationsForUser {
    id
    name
    targetType
    repositorySelection
    settingsUrl
  }
}
    `;

/**
 * __useUserInstallsQuery__
 *
 * To run a query within a React component, call `useUserInstallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInstallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInstallsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInstallsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserInstallsQuery, UserInstallsQueryVariables>) {
        return ApolloReactHooks.useQuery<UserInstallsQuery, UserInstallsQueryVariables>(UserInstallsDocument, baseOptions);
      }
export function useUserInstallsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserInstallsQuery, UserInstallsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<UserInstallsQuery, UserInstallsQueryVariables>(UserInstallsDocument, baseOptions);
        }
export type UserInstallsQueryHookResult = ReturnType<typeof useUserInstallsQuery>;
export type UserInstallsLazyQueryHookResult = ReturnType<typeof useUserInstallsLazyQuery>;
export type UserInstallsQueryResult = ApolloReactCommon.QueryResult<UserInstallsQuery, UserInstallsQueryVariables>;
export const GithubRepoInformationDocument = gql`
    query githubRepoInformation($githubUrl: String!) {
  githubRepoInformation(githubUrl: $githubUrl) {
    exists
    repoInfo {
      htmlUrl
      id
      owner
      name
      fullName
      private
      description
      defaultBranch
    }
  }
}
    `;

/**
 * __useGithubRepoInformationQuery__
 *
 * To run a query within a React component, call `useGithubRepoInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGithubRepoInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGithubRepoInformationQuery({
 *   variables: {
 *      githubUrl: // value for 'githubUrl'
 *   },
 * });
 */
export function useGithubRepoInformationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GithubRepoInformationQuery, GithubRepoInformationQueryVariables>) {
        return ApolloReactHooks.useQuery<GithubRepoInformationQuery, GithubRepoInformationQueryVariables>(GithubRepoInformationDocument, baseOptions);
      }
export function useGithubRepoInformationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GithubRepoInformationQuery, GithubRepoInformationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GithubRepoInformationQuery, GithubRepoInformationQueryVariables>(GithubRepoInformationDocument, baseOptions);
        }
export type GithubRepoInformationQueryHookResult = ReturnType<typeof useGithubRepoInformationQuery>;
export type GithubRepoInformationLazyQueryHookResult = ReturnType<typeof useGithubRepoInformationLazyQuery>;
export type GithubRepoInformationQueryResult = ApolloReactCommon.QueryResult<GithubRepoInformationQuery, GithubRepoInformationQueryVariables>;
export const CmsVendorsForGatsbyProvisionScriptDocument = gql`
    query cmsVendorsForGatsbyProvisionScript($siteId: UUID!) {
  cmsVendorsForGatsbyProvisionScript(siteId: $siteId)
}
    `;

/**
 * __useCmsVendorsForGatsbyProvisionScriptQuery__
 *
 * To run a query within a React component, call `useCmsVendorsForGatsbyProvisionScriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsVendorsForGatsbyProvisionScriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsVendorsForGatsbyProvisionScriptQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCmsVendorsForGatsbyProvisionScriptQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CmsVendorsForGatsbyProvisionScriptQuery, CmsVendorsForGatsbyProvisionScriptQueryVariables>) {
        return ApolloReactHooks.useQuery<CmsVendorsForGatsbyProvisionScriptQuery, CmsVendorsForGatsbyProvisionScriptQueryVariables>(CmsVendorsForGatsbyProvisionScriptDocument, baseOptions);
      }
export function useCmsVendorsForGatsbyProvisionScriptLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CmsVendorsForGatsbyProvisionScriptQuery, CmsVendorsForGatsbyProvisionScriptQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CmsVendorsForGatsbyProvisionScriptQuery, CmsVendorsForGatsbyProvisionScriptQueryVariables>(CmsVendorsForGatsbyProvisionScriptDocument, baseOptions);
        }
export type CmsVendorsForGatsbyProvisionScriptQueryHookResult = ReturnType<typeof useCmsVendorsForGatsbyProvisionScriptQuery>;
export type CmsVendorsForGatsbyProvisionScriptLazyQueryHookResult = ReturnType<typeof useCmsVendorsForGatsbyProvisionScriptLazyQuery>;
export type CmsVendorsForGatsbyProvisionScriptQueryResult = ApolloReactCommon.QueryResult<CmsVendorsForGatsbyProvisionScriptQuery, CmsVendorsForGatsbyProvisionScriptQueryVariables>;
export const ProvisionSetupDataForSiteDocument = gql`
    mutation provisionSetupDataForSite($siteId: UUID!, $workspaceId: UUID!) {
  provisionSetupDataForSite(siteId: $siteId, workspaceId: $workspaceId) {
    siteProvisionJob {
      id
      repoUrl
      status
      workspaceId
      siteId
      error
    }
    validation {
      success
      message
      errorType
    }
  }
}
    `;
export type ProvisionSetupDataForSiteMutationFn = ApolloReactCommon.MutationFunction<ProvisionSetupDataForSiteMutation, ProvisionSetupDataForSiteMutationVariables>;

/**
 * __useProvisionSetupDataForSiteMutation__
 *
 * To run a mutation, you first call `useProvisionSetupDataForSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionSetupDataForSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionSetupDataForSiteMutation, { data, loading, error }] = useProvisionSetupDataForSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useProvisionSetupDataForSiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProvisionSetupDataForSiteMutation, ProvisionSetupDataForSiteMutationVariables>) {
        return ApolloReactHooks.useMutation<ProvisionSetupDataForSiteMutation, ProvisionSetupDataForSiteMutationVariables>(ProvisionSetupDataForSiteDocument, baseOptions);
      }
export type ProvisionSetupDataForSiteMutationHookResult = ReturnType<typeof useProvisionSetupDataForSiteMutation>;
export type ProvisionSetupDataForSiteMutationResult = ApolloReactCommon.MutationResult<ProvisionSetupDataForSiteMutation>;
export type ProvisionSetupDataForSiteMutationOptions = ApolloReactCommon.BaseMutationOptions<ProvisionSetupDataForSiteMutation, ProvisionSetupDataForSiteMutationVariables>;
export const SiteProvisionJobChangedDocument = gql`
    subscription siteProvisionJobChanged($id: ID!) {
  siteProvisionJobChanged(id: $id) {
    id
    workspaceId
    status
    siteId
    error
    repoUrl
  }
}
    `;

/**
 * __useSiteProvisionJobChangedSubscription__
 *
 * To run a query within a React component, call `useSiteProvisionJobChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSiteProvisionJobChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteProvisionJobChangedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSiteProvisionJobChangedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<SiteProvisionJobChangedSubscription, SiteProvisionJobChangedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<SiteProvisionJobChangedSubscription, SiteProvisionJobChangedSubscriptionVariables>(SiteProvisionJobChangedDocument, baseOptions);
      }
export type SiteProvisionJobChangedSubscriptionHookResult = ReturnType<typeof useSiteProvisionJobChangedSubscription>;
export type SiteProvisionJobChangedSubscriptionResult = ApolloReactCommon.SubscriptionResult<SiteProvisionJobChangedSubscription>;
export const LogsForSiteProvisionJobDocument = gql`
    query logsForSiteProvisionJob($siteId: UUID!, $jobId: ID!, $offset: Int) {
  logsForSiteProvisionJob(
    siteId: $siteId
    siteProvisionJobId: $jobId
    offset: $offset
  ) @connection(key: "siteProvisionLogs", filter: ["siteProvisionJobId"]) {
    id
    message
    timestamp
    sourceStream
    command
  }
}
    `;

/**
 * __useLogsForSiteProvisionJobQuery__
 *
 * To run a query within a React component, call `useLogsForSiteProvisionJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogsForSiteProvisionJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogsForSiteProvisionJobQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      jobId: // value for 'jobId'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useLogsForSiteProvisionJobQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LogsForSiteProvisionJobQuery, LogsForSiteProvisionJobQueryVariables>) {
        return ApolloReactHooks.useQuery<LogsForSiteProvisionJobQuery, LogsForSiteProvisionJobQueryVariables>(LogsForSiteProvisionJobDocument, baseOptions);
      }
export function useLogsForSiteProvisionJobLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LogsForSiteProvisionJobQuery, LogsForSiteProvisionJobQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<LogsForSiteProvisionJobQuery, LogsForSiteProvisionJobQueryVariables>(LogsForSiteProvisionJobDocument, baseOptions);
        }
export type LogsForSiteProvisionJobQueryHookResult = ReturnType<typeof useLogsForSiteProvisionJobQuery>;
export type LogsForSiteProvisionJobLazyQueryHookResult = ReturnType<typeof useLogsForSiteProvisionJobLazyQuery>;
export type LogsForSiteProvisionJobQueryResult = ApolloReactCommon.QueryResult<LogsForSiteProvisionJobQuery, LogsForSiteProvisionJobQueryVariables>;
export const SiteProvisionLogCreatedDocument = gql`
    subscription siteProvisionLogCreated($jobId: ID!) {
  siteProvisionLogCreated(siteProvisionJobId: $jobId) {
    id
    timestamp
    message
    sourceStream
    command
    invocationId
  }
}
    `;

/**
 * __useSiteProvisionLogCreatedSubscription__
 *
 * To run a query within a React component, call `useSiteProvisionLogCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSiteProvisionLogCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteProvisionLogCreatedSubscription({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useSiteProvisionLogCreatedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<SiteProvisionLogCreatedSubscription, SiteProvisionLogCreatedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<SiteProvisionLogCreatedSubscription, SiteProvisionLogCreatedSubscriptionVariables>(SiteProvisionLogCreatedDocument, baseOptions);
      }
export type SiteProvisionLogCreatedSubscriptionHookResult = ReturnType<typeof useSiteProvisionLogCreatedSubscription>;
export type SiteProvisionLogCreatedSubscriptionResult = ApolloReactCommon.SubscriptionResult<SiteProvisionLogCreatedSubscription>;
